module.exports = __webpack_public_path__ + "img/9788952760500.762f902b.jpg";